import { useMutation, useQueryClient } from "@tanstack/react-query";

import { client } from "@/config/client";

export const useRemoveRole = function (model, id) {
  const queryClient = useQueryClient();

  const mutationFn = (role) => {
    return client[model].removeRole(id, role);
  };

  const onSuccess = () => {
    return queryClient.invalidateQueries({ queryKey: [model] });
  };

  return useMutation({
    mutationFn,
    onSuccess,
  });
};
